import { CIcon } from '~/icons/types'
export const ciVideoUpload: CIcon = {
  name: 'video-upload',
  type: 'solid',
  width: 90,
  height: 74,
  paths: [
    {
      d:
        'M10.663.644h64.633c5.577 0 10.1 4.522 10.1 10.099V42.58a19.08 19.08 0 0 0-11.11-3.561c-10.597 0-19.188 8.59-19.188 19.188a19.08 19.08 0 0 0 3.561 11.109H10.663c-5.576 0-10.099-4.523-10.099-10.1V10.744C.564 5.166 5.087.644 10.664.644Zm24.945 45.514 20.601-11.895a3.79 3.79 0 0 0 1.92-3.32c0-1.39-.718-2.63-1.92-3.325L35.608 15.724a3.798 3.798 0 0 0-3.838 0 3.795 3.795 0 0 0-1.919 3.322v23.787c0 1.39.717 2.63 1.92 3.325a3.83 3.83 0 0 0 1.918.52c.658 0 1.319-.173 1.919-.52Zm23.53 12.05c0-8.366 6.783-15.149 15.148-15.149 8.366 0 15.149 6.783 15.149 15.149s-6.783 15.148-15.149 15.148c-8.365 0-15.148-6.782-15.148-15.148Zm20.198 0a2.018 2.018 0 0 0 1.428-3.448l-5.05-5.05a2.021 2.021 0 0 0-2.856 0l-5.049 5.05a2.017 2.017 0 0 0 0 2.856c.79.79 2.066.79 2.856 0l1.602-1.602v9.263a2.02 2.02 0 0 0 4.04 0v-9.263l1.6 1.602c.395.394.912.592 1.429.592Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ]
}
